// extracted by mini-css-extract-plugin
export default {"ac-quote":"qAZV5RMhA_CRBsyzoIng"};